import { render, staticRenderFns } from "./resolveTime.vue?vue&type=template&id=484cc09a&scoped=true&"
import script from "./resolveTime.vue?vue&type=script&lang=js&"
export * from "./resolveTime.vue?vue&type=script&lang=js&"
import style0 from "./resolveTime.vue?vue&type=style&index=0&id=484cc09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cc09a",
  null
  
)

export default component.exports